import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { authApi } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [password, setPassword] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      await authApi.reset(token, password);
      toast.success("Password reset. Please sign in.");
      nav("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas p-6">
      <div className="max-w-md w-full bg-white border border-canvas-border rounded-2xl p-10 shadow-soft">
        <h1 className="font-display text-2xl font-bold text-espresso mb-2">Choose a new password</h1>
        <form onSubmit={submit} className="space-y-4 mt-6">
          <input
            data-testid="reset-password"
            type="password"
            minLength={8}
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 bg-white border border-canvas-border rounded-lg brand-focus"
            placeholder="New password"
          />
          <button data-testid="reset-submit" className="w-full py-3 bg-espresso text-canvas rounded-lg font-semibold hover:bg-espresso-light transition-colors">Reset password</button>
        </form>
        <Link to="/login" className="text-sm text-gold mt-4 inline-block">Back to sign in</Link>
      </div>
    </div>
  );
}
